// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export const EXPLICIT_SIGN_OUT_KEY = "riddle.auth.explicitSignOut";

export function markExplicitSignOut(): void {
  try {
    window.localStorage.setItem(EXPLICIT_SIGN_OUT_KEY, "1");
  } catch {
  }
}

export function hasExplicitSignOut(): boolean {
  try {
    return window.localStorage.getItem(EXPLICIT_SIGN_OUT_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearExplicitSignOut(): void {
  try {
    window.localStorage.removeItem(EXPLICIT_SIGN_OUT_KEY);
  } catch {
  }
}

export const SIGN_OUT_BROADCAST_KEY = "riddle.auth.signOutBroadcast";

export function broadcastSignOut(): void {
  try {
    window.localStorage.setItem(SIGN_OUT_BROADCAST_KEY, String(Date.now()));
  } catch {
  }
}

export function subscribeToSignOutBroadcast(onSignOut: () => void): () => void {
  const listener = (event: StorageEvent): void => {
    if (event.key === SIGN_OUT_BROADCAST_KEY && event.newValue !== null) {
      onSignOut();
    }
  };
  window.addEventListener("storage", listener);
  return () => window.removeEventListener("storage", listener);
}
